import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import Footer from "../../components/Footer";
import { Outlet } from "react-router";

const Layout = () => {
  const location = useLocation();
  console.log(location);
  const [sidebarEnabler, setSidebarEnabler] = useState(false);
  const [isFooter, setIsFooter] = useState(false);
  // useEffect(() => {
  //   if (location.pathname !== "/dashboard/onboarding/create-form") {
  //     localStorage.removeItem("formData");
  //     localStorage.removeItem("formTitle");
  //     localStorage.removeItem("formSubtitle");
  //     localStorage.removeItem("templateTitle");
  //   }
  // }, [location]);
  useEffect(() => {
    if (
      location.pathname === "/dashboard/onboarding/edit-forms" ||
      location.pathname === "/dashboard/onboarding/edit-form" ||
      location.pathname === "/dashboard/onboarding/create-form"
    ) {
      setIsFooter(true);
    } else {
      setIsFooter(false);
    }
  });

  const getSidebarToggleState = (toggleState) => {
    setSidebarEnabler(toggleState);
  };
  return (
    <div className="d-flex">
      <div className="sidebarWraper">
        <Sidebar
          getSidebarToggleState={(toggleState) => {
            getSidebarToggleState(toggleState);
          }}
          sidebarEnabler={sidebarEnabler}
        />
      </div>
      <div
        className={
          sidebarEnabler
            ? "container_main collapseView"
            : "container_main containerSpace mainWrap"
        }
      >
        <div className="ht-box ">
          <Header
            getSidebarToggleState={(toggleState) => {
              getSidebarToggleState(toggleState);
            }}
          />
          <Outlet context={{ state: sidebarEnabler }} />
        </div>
        {isFooter === true && <Footer sidebarEnabler={sidebarEnabler} />}
      </div>
    </div>
  );
};

export default Layout;
